import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Input } from "../../components/ui/input";
import { Button } from "../../components/ui/button";
import { toast } from "sonner";
import { LayoutGrid, Shield } from "lucide-react";

export default function AdminModuleCatalogue() {
  const [mods, setMods] = useState([]);
  const [edits, setEdits] = useState({});

  const load = () => api.get("/billing/modules").then((r) => setMods(r.data));
  useEffect(() => { load(); }, []);

  const save = async (mk) => {
    const v = edits[mk];
    if (!v) return;
    try {
      await api.put(`/admin/module-catalogue/${mk}`, { price_per_unit_monthly: Number(v) });
      toast.success(`Updated ${mk}`);
      setEdits({ ...edits, [mk]: undefined });
      load();
    } catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  };

  return (
    <div className="space-y-6" data-testid="admin-module-catalogue-page">
      <div>
        <div className="text-xs text-gray-500 flex items-center gap-1"><Shield className="w-3 h-3" strokeWidth={2.5} /> Platform Admin</div>
        <h1 className="text-3xl md:text-4xl font-extrabold flex items-center gap-2"><LayoutGrid className="w-7 h-7 text-orange-400" strokeWidth={2.5} /> Module Catalogue</h1>
        <p className="text-sm text-gray-500 mt-1">Edit per-unit pricing. Changes apply to new subscriptions only — existing orgs keep their price.</p>
      </div>
      <div className="glass p-6 rounded-lg overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="text-[10px] uppercase tracking-wider text-gray-500">
            <tr>
              <th className="text-left pb-2">Module</th>
              <th className="text-left pb-2">Category</th>
              <th className="text-right pb-2">Current ₹/unit/mo</th>
              <th className="text-right pb-2">New Price</th>
              <th className="text-right pb-2">Action</th>
            </tr>
          </thead>
          <tbody>
            {mods.map((m) => (
              <tr key={m.module_key} className="border-t border-gray-200" data-testid={`cat-row-${m.module_key}`}>
                <td className="py-2.5">
                  <div className="font-semibold">{m.module_name}</div>
                  <div className="text-[10px] text-gray-500 font-mono">{m.module_key}</div>
                </td>
                <td><span className="px-2 py-0.5 rounded-full text-[10px] uppercase tracking-widest bg-gray-50">{m.module_category}</span></td>
                <td className="text-right font-bold">₹{m.price_per_unit_monthly}</td>
                <td className="text-right">
                  <Input type="number" placeholder={String(m.price_per_unit_monthly)} value={edits[m.module_key] || ""}
                    onChange={(e) => setEdits({ ...edits, [m.module_key]: e.target.value })}
                    className="w-24 bg-gray-50 border-gray-200 text-right inline-block" disabled={m.is_core_module}
                    data-testid={`price-${m.module_key}`} />
                </td>
                <td className="text-right">
                  <Button size="sm" onClick={() => save(m.module_key)} disabled={!edits[m.module_key] || m.is_core_module} className="f360-gradient border-0" data-testid={`save-${m.module_key}`}>Save</Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
